import Model from '@models/model';
import { PROPOSAL_STATUS_SIGNED } from '@models/proposal';
import Vue from '@vue/compat';

export default class ProposalWizard extends Model {
    details = {
        customer: {},
        locations: [],
        purchase_orders: [],
    };

    resource() {
        return 'wizard';
    }

    isCompleted(proposal, feature) {
        if (this.details.purchase_orders.length > 0 && this.details.purchase_orders.filter((po) => !po.type).length) {
            Vue.swal({
                title: 'Purchase Order Type Required',
                icon: 'warning',
                text: 'Please apply a type to all purchase orders before continuing',
                type: 'error',
            });
            return false;
        }

        if (this.details.customer.files.length === 0 && proposal.status !== PROPOSAL_STATUS_SIGNED) {
            const ordersWithMissingPurchaseOrders = this.details.locations.filter(
                (location) => location.orders.filter(
                    (order) => !order.customer_purchase_order_id,
                ).length,
            ).length;

            if (ordersWithMissingPurchaseOrders) {
                Vue.swal({
                    title: 'Proposal Or PO Required',
                    icon: 'warning',
                    text: 'Please upload a signed proposal or apply a purchase order to all orders before continuing',
                    type: 'error',
                });
                return false;
            }
        }

        if (proposal.purchase_order_required) {
            const ordersWithMissingPurchaseOrders = this.details.locations.filter(
                (location) => location.orders.filter(
                    (order) => !order.customer_purchase_order_id,
                ).length,
            ).length;

            if (ordersWithMissingPurchaseOrders) {
                Vue.swal({
                    title: 'PO Required',
                    icon: 'warning',
                    text: 'A purchase order is required to win this proposal',
                    type: 'error',
                });
                return false;
            }
        }

        // require the job when recap is required
        if (proposal.recap_required) {
            const ordersWithMissingJobs = this.details.locations.filter(
                (location) => location.orders.filter(
                    (order) => !order.job_id,
                ).length,
            ).length;

            if (ordersWithMissingJobs) {
                Vue.swal({
                    title: 'Job Required for Recap',
                    icon: 'warning',
                    text: 'Please apply a job to all orders before continuing',
                    type: 'error',
                });
                return false;
            }
        }

        if (feature.enabled('dms-invoicing')) {
            // if the customer does not have a customer_id on proposal and customer_id on details customer
            if (!proposal.customer_id && !this.details.customer.customer_id) {
                Vue.swal({
                    title: 'DMS Customer ID Required',
                    icon: 'warning',
                    text: 'Please add a customer ID before continuing',
                    type: 'error',
                });
                return false;
            }

            // check to make sure all locations have a customer_location_id
            const locationsToFix = !!this.details.locations.filter((location) => !location.customer_location_id).length;

            if (locationsToFix) {
                Vue.swal({
                    title: 'DMS Location IDs Required',
                    icon: 'warning',
                    text: 'Please add a location ID for each location before continuing',
                    type: 'error',
                });
                return false;
            }
        }

        // if the customer does not have a billing address
        if (!this.details.customer.billing_address_line_1) {
            Vue.swal({
                title: 'Billing Address Required',
                icon: 'warning',
                text: 'Please add a billing address before continuing',
                type: 'error',
            });
            return false;
        }

        const itemsToFix = !!this.details.locations
            .filter((location) => location.orders.filter((o) => o.items.filter((i) => i.item_missing).length).length)
            .length;

        if (itemsToFix) {
            Vue.swal({
                title: 'New Items Found',
                icon: 'warning',
                text: 'Please submit item requests for all items that do not exist in the system before continuing then return to the proposal to complete the customer setup.',
                type: 'error',
            });

            return false;
        }

        if (proposal.proposal_file_tax_exempt_id) {
            Vue.swal({
                title: 'Certficate Validation Required',
                icon: 'info',
                text: 'The tax exempt certification needs to be validated on Avalara. Taxes will apply on all invoices until this is complete.',
                type: 'info',
            });
        }

        return true;
    }
}
